var _g, _path, _g2, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 851,
    viewBox: "0 0 252 851",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-372 8L79 8.00002C156.32 8.00002 219 70.6802 219 148L219 351",
    stroke: "url(#paint0_linear_90_922)",
    strokeWidth: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194 337L220 363L246 337",
    stroke: "white",
    strokeWidth: 16
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.311 851.016L210.043 533.017L226.043 533L230.311 850.999L214.311 851.016Z",
    fill: "url(#paint1_linear_90_922)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79 1.93749e-05L-372 0L-372 16L79 16C151.902 16 211 75.0984 211 148L211 351L227 351L227 148C227 66.2619 160.738 2.28864e-05 79 1.93749e-05Z",
    fill: "url(#paint2_linear_90_922)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.343 342.657L199.657 331.343L220 351.686L240.343 331.343L251.657 342.657L220 374.314L188.343 342.657Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.311 851.016L210.043 533.017L226.043 533L230.311 850.999L214.311 851.016Z",
    fill: "url(#paint3_linear_90_922)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220 483C226.627 483 232 477.627 232 471C232 464.373 226.627 459 220 459C213.373 459 208 464.373 208 471C208 477.627 213.373 483 220 483ZM220 499C235.464 499 248 486.464 248 471C248 455.536 235.464 443 220 443C204.536 443 192 455.536 192 471C192 486.464 204.536 499 220 499Z",
    fill: "#4DE295"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_90_922",
    x1: 219.418,
    y1: 69.4975,
    x2: 0.629329,
    y2: 12.9226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C2E40",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_90_922",
    x1: 219.742,
    y1: 723.851,
    x2: 220.103,
    y2: 523.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C2E40",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_90_922",
    x1: 219.418,
    y1: 69.4975,
    x2: 0.629318,
    y2: 12.9226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C2E40",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_90_922",
    x1: 219.742,
    y1: 723.851,
    x2: 220.103,
    y2: 523.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C2E40",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.b65dc77581045ab9415cd9d35fcfa0db.svg";
export { ForwardRef as ReactComponent };